import logo from './logo.svg';
import './App.css';
import OnboardUser from 'pages/OnboardUser';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return (
    <div className="App">
        <OnboardUser />
    </div>
  );
}

export default App;
